import React from 'react';
import { useAppTheme } from '@/hooks/useAppTheme';

 export const LinearGradient = ({ colors, style, children, start, end, ...props }: any) => {
    const gradientStyle = {
      flex: 1,
      background: `linear-gradient(135deg, ${colors?.[0] || '#9D919F'} 0%, ${colors?.[1] || '#899CA8'} 100%)`,
      ...style,
    };
    return <div style={gradientStyle} {...props}>{children}</div>;
  };

interface GradientViewProps {
  children?: React.ReactNode;
  style?: any;
  colors?: string[];
}

export const GradientView: React.FC<GradientViewProps> = ({
  children,
  style,
  colors,
}) => {
  const theme = useAppTheme();

  const gradientColors = colors || [theme.gradientStart, theme.gradientEnd];

  return (
    <LinearGradient
      colors={gradientColors}
      style={[{ flex: 1 }, style]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
    >
      {children}
    </LinearGradient>
  );
};

export default GradientView;
